// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimPaymentAccountDto
 */
export interface IClaimPaymentAccountDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimPaymentAccountDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimPaymentAccountDto
     */
    policy_id?: number;
}

/**
 * Check if a given object implements the IClaimPaymentAccountDto interface.
 */
export function instanceOfIClaimPaymentAccountDto(value: object): value is IClaimPaymentAccountDto {
    return true;
}

export function IClaimPaymentAccountDtoFromJSON(json: any): IClaimPaymentAccountDto {
    return IClaimPaymentAccountDtoFromJSONTyped(json, false);
}

export function IClaimPaymentAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimPaymentAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'policy_id': json['policy_id'] == null ? undefined : json['policy_id'],
    };
}

export function IClaimPaymentAccountDtoToJSON(json: any): IClaimPaymentAccountDto {
    return IClaimPaymentAccountDtoToJSONTyped(json, false);
}

export function IClaimPaymentAccountDtoToJSONTyped(value?: IClaimPaymentAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['account_id'],
        'policy_id': value['policy_id'],
    };
}

